import React, { PureComponent } from 'react';
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css';
import { Button, DialogContainer, TextField } from 'react-md';
import { NotificationManager } from 'react-notifications';
import { browserHistory } from 'react-router';
import ApiRequestService from '../component/ApiRequestService';
import Error from '../component/ErrorDispaly.js';
import LoadingSpinner from '../component/LoadingSpinner';
import SecureShow from '../component/SecureShow';
import TableRow from '../component/TableRow';
import styles from '../css/styles.css.js';
import { AppSetting, AppProperties } from '../common/function';


let subsection = {
  subsection_name: '',
  subsection_id: '',
  section_id: '',
  course_id: ''
};
export default class SubSections extends PureComponent {
  AppSetting = AppSetting();
  appProperties = AppProperties();
  baseFolder = this.appProperties.baseFolder;
  constructor(props) {
    super(props);
    this.state = {
      subsections: [],
      temp_subsection: subsection,
      temp_id: '',
      addMode: true,
      visible: false,
      course_id: this.props.location.query.course_id,
      course_name: this.props.location.query.course_name,
      section_name: this.props.location.query.section_name,
      section_id: this.props.location.query.section_id,
      is_lti_enabled: this.props.location.query.is_lti_enabled,
      semester_id: this.props.location.query.semester_id,
      semester_name: this.props.location.query.semester_name,
      is_current_semester: this.props.location.query.is_current_semester === "true",
      errorMessage: '',
      errorType: '',
      loading:false
    };
    this.isEnterPressed = this.isEnterPressed.bind(this);        
    this.deleteSubSection = this.deleteSubSection.bind(this);
    this.addSubSection = this.addSubSection.bind(this);
    this.changeSubSectionName = this.changeSubSectionName.bind(this);
    this.updateSubSection = this.updateSubSection.bind(this);
    this.updateSubSectionResponseHandler = this.updateSubSectionResponseHandler.bind(
      this
    );
  }

  addBreadCrumbs = () => {
    this.props.replaceBreadCrumb([
      {
        name:(this.appProperties.schoolMode?'All Standards':'All Courses') ,
        type: '',
        onclickPath: 'Courses'
      },
      {
        name: this.state.course_name,
        type: (this.appProperties.schoolMode?'Standards':'Courses'),
        onclickPath:
          'sections?course_id=' +
          this.state.course_id +
          '&course_name=' +
          this.state.course_name +
          '&is_lti_enabled=' +
          this.state.is_lti_enabled +
          '&semester_id=' +
          this.state.semester_id +
          '&semester_name=' +
          this.state.semester_name +
          '&is_current_semester=' +
          this.state.is_current_semester
      },
      {
        name: this.state.section_name,
        type: 'Sections',
        onclickPath: 
        'sectionTabs?section_id=' +
        this.state.section_id +
        '&section_name=' +
        this.state.section_name +
        '&course_id=' +
        this.state.course_id +
        '&course_name=' +
        this.state.course_name +
        '&is_lti_enabled=' +
        this.state.is_lti_enabled +
        '&semester_id=' +
        this.state.semester_id +
        '&semester_name=' +
        this.state.semester_name +
        '&is_current_semester=' +
        this.state.is_current_semester
      }
    ]);
  };

  componentWillUpdate() {
    this.addBreadCrumbs();
  }

  componentWillMount() {
    var cour_id = parseInt(this.state.course_id, 10);
    var sec_id = parseInt(this.state.section_id, 10)
    const payload = {
      section_id: sec_id,
      course_id: cour_id,
    };
    if (this.state.semester_id) {
      payload.semesterID = parseInt(this.state.semester_id, 10);
    }
    this.setState({
      loading:true
    });
    ApiRequestService({
      method: 'post',
      url: '/getAllSubSections',
      data: payload
    }).then(res => {
      this.setState({
        loading:false
      });
      if (res.data.data.subsection_names != null) {
         this.setState({
         subsections: res.data.data.subsection_names
         });
       }
    });
  }
  componentWillUnmount() {
    this.removeBreadCrumbs();
  }

  removeBreadCrumbs = () => {
      this.props.replaceBreadCrumb([
      ]);     
  };


  addSubSection() {
    var sub_id = parseInt(this.state.course_id, 10); 
    var sec_id =  parseInt(this.state.section_id, 10);
    
    const payload = {
      subsection_name: this.state.temp_subsection.subsection_name,
      course_id: sub_id,
      section_id: sec_id
    };
    this.setState({
      loading:true
    });
    ApiRequestService({
      method: 'post',
      url: '/addSubSection',
      data: payload
    }).then(res => {
      this.setState({
        loading:false
      });
      if (res.data.message !== null && res.data.message !== '') {
        NotificationManager.error(res.data.message, 'ERROR', 3000);
      }
      if (res.data.data != null) {
        var tempSectionArr = this.state.subsections.slice();
        tempSectionArr.push({
          subsection_name: res.data.data.subsection_name,
          subsection_id: res.data.data.subsection_id,
          course_id: res.data.data.course_id,
          section_id : res.data.data.section_id
        });
        this.setState({
          subsections: tempSectionArr
        });
      }
      this.hide();
    });
  }

  editSection(id) {
    this.setState({
      temp_subsection: this.state.subsections[id],
      temp_id: id,
      addMode: false
    });

    this.show(false);
  }
  updateSubSectionResponseHandler(res) {
    this.setState({
      loading:false
    });
    if (res.data.message !== null && res.data.message !== '') {
      NotificationManager.error(res.data.message, 'ERROR', 3000);
    }
    if (res.data.data != null) {
      let tempSubSections = this.state.subsections;
      tempSubSections[this.state.temp_id] = this.state.temp_subsection;
      this.setState({
        subsections: tempSubSections,
        temp_subsection: subsection
      });
    }
    this.hide();
  }

  updateSubSection() {
    var sub_id = parseInt(this.state.course_id, 10);
    var sec_id =  parseInt(this.state.section_id, 10);

    const payload = {
      subsection_name: this.state.temp_subsection.subsection_name,
      subsection_id: this.state.temp_subsection.subsection_id,
      course_id: sub_id,
      section_id: sec_id
    };
    this.setState({
      loading:true
    });
    ApiRequestService({
      method: 'post',
      url: '/updateSubSection',
      data: payload
    }).then(this.updateSubSectionResponseHandler);
  }
  deleteSubSection(id) {
    var sub_id = parseInt(this.state.course_id, 10);
    var sec_id =  parseInt(this.state.section_id, 10);
    const payload = {
      course_id: sub_id,
      section_id: sec_id,
      subsection_id: this.state.subsections[id].subsection_id
    };
    this.setState({
      loading:true
    });
    ApiRequestService({
      method: 'post',
      url: '/deleteSubSection',
      data: payload
    }).then(res => {
      if (res.data.message !== null && res.data.message !== '') {
        NotificationManager.error(res.data.message, 'ERROR', 3000);
      }else{
        this.state.subsections.splice(id, 1);
        this.setState({
          subsections:  this.state.subsections
        });
    }
    this.setState({
      loading:false
    });
    });
  }

  changeSubSectionName(value) {
    let newSubSection = this.state.temp_subsection;
    newSubSection.subsection_name = value;
    this.setState({
      temp_subsection: newSubSection
    });
  }

  show = isSubSectionEnable => {
    if (isSubSectionEnable) {
      this.setState({
        temp_subsection: {
          subsection_name: '',
          subsection_id: '',
          section_id: '',
          course_id: ''
        }
      });
    }

    this.setState({ visible: true });
  };

  hide = () => {
    this.setState({
      visible: false,
      addMode: true
    });
  };

  subjPage() {
    browserHistory.push(this.baseFolder + 'courses');
  }

  delete = id => {
    confirmAlert({
      title: 'Are you sure want to delete this Subsection?',
      message: 'Press Confirm to submit',

      confirmLabel: 'Cancel',
      cancelLabel: 'Confirm',
      onCancel: () => this.deleteSubSection(id)
      //   onCancel: () => dissmiss,
/*       customUI: ({ onClose }) => {
        return (
          <div className='custom-ui'>
            <h1>Are you sure want to delete this Section?</h1>
            <p>Press Confirm to submit</p>
            <button onClick={() => {
                this.handleClickDelete()
                onClose()
            }}>Confirm</button>
            <button onClick={onClose}>Cancel</button>
          </div>
        )
      } */
    });
  };

  isEnterPressed(event){
    var code = event.keyCode || event.which;
    if(code === 13) { //13 is the enter keycode
      if (this.state.addMode) {
        this.addSubSection();
      } else{
       this.updateSubSection();
      }
   }
  }

  render() {
    // console.log('subsection',this.props)
    let button = null;
    if (this.state.addMode) {
      button = (
        <Button style={styles.addButton} onClick={this.addSubSection}>
          Add SubSection
        </Button>
      );
    } else {
      button = (
        <Button style={styles.addButton} onClick={this.updateSubSection}>
          Update SubSection
        </Button>
      );
    }
    var cancelButton = (
      <Button style={styles.cancelButton} onClick={this.hide}>
        Cancel
      </Button>
    );

    const actions = [];
    actions.push(button);
    actions.push(cancelButton);

    var tbody = null;
    if (this.state.subsections != null) {
      tbody = (
        <tbody>
          {this.state.subsections.map((subsection, i) => (
            <TableRow
              key={i}
              data={subsection}
              pushId={'Subsections'}
              id={subsection.subsection_id}
              name={subsection.subsection_name}
              title={'SubSections'}
              type={''}
              url={
                'subSectionTabs?subsection_id=' +
                subsection.subsection_id +
                '&subsection_name=' +
                subsection.subsection_name +
                '&section_id=' +
                subsection.section_id +
                '&course_id=' +
                this.state.course_id +
                '&course_name=' +
                this.state.course_name +
                '&section_name=' +
                this.state.section_name +
                '&is_lti_enabled=' +
                this.state.is_lti_enabled +
                '&semester_id=' +
                this.state.semester_id +
                '&semester_name=' +
                this.state.semester_name +
                '&is_current_semester=' +
                this.state.is_current_semester
              }
              onEditClick={() => this.editSection(i)}
              onDeleteClick={() => this.delete(i)}
              instructorSubject = {true}
              disableActionButtons={this.state.is_current_semester === false}
            />
          ))}
        </tbody>
      );
    }

    return (
      (this.state.loading)?
         <LoadingSpinner loading={this.state.loading} />
      :
      <SecureShow targetRole={1}>
        <div>
          {/* <div onClick = {this.subjPage} style={subjPage}>Courses >  </div>
            <div onClick = {this.sectionPage} style={sectionPage}>Sections</div> */}

          <div style={styles.sectionTitle}>
            {this.state.semester_name} | Subsections under - {this.state.section_name}
            {(parseInt(window.localStorage.getItem(`${this.AppSetting.REACT_APP_UNIVERSITY_SUFFIX}_role`), 10)) >= 2 ? (
            <div style={styles.floatRight}>
            <Button className="archive-button" primary raised
              disabled={this.state.is_current_semester === false}
              style={{float: "right"}}
                onClick={() => this.show(true)}>
                  Add a New Subsection
              </Button>
            </div>
          ) : (
                ''
        )}
          </div>

          <DialogContainer
            id="simple-action-dialog"
            visible={this.state.visible}
            onHide={this.hide}
            actions={actions}
            width="500px"
            //title="New Section"
          >
          <p style={{fontSize:"medium"}}><label for="secId">New Subsection</label></p>
            <TextField
              id="secId"
              type="text"
              name="subsection_name"
              defaultValue={this.state.temp_subsection.subsection_name || ''}
              onChange={this.changeSubSectionName}
              onKeyPress={this.isEnterPressed.bind(this)}
            />
          </DialogContainer>
          <table style={styles.sectionTable}>
            <thead style={styles.thead}>
              <tr>
                <th>ID</th>
                <th>SubSections</th>
                <th>Actions</th>
              </tr>
            </thead>

            {tbody}
          </table>
          <Error
            type={this.state.errorType}
            message={this.state.errorMessage}
          />
        </div>
      </SecureShow>
    );
  }
}
